module.exports = __webpack_public_path__ + "fonts/roboto-v16-cyrillic_latin-700.ttf";